import { useState, useEffect } from 'react';
import SelectWhatsappModal from '../../SelectWhatsappModal';

export default function Hero({ logoSrc = '/boggler-logo.webp', waitlistUrl = '#' }) {
  const [rotatingWord, setRotatingWord] = useState('you');
  const [showSelectWhatsapp, setShowSelectWhatsapp] = useState(false);

  const words = [
    'you', 'your journey', 'your growth', 'your questions',
    'your path', 'your goals', 'your progress'
  ];

  useEffect(() => {
    let currentIndex = 0;
    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % words.length;
      setRotatingWord(words[currentIndex] || 'you');
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 py-20">
      <SelectWhatsappModal show={showSelectWhatsapp} onClose={() => setShowSelectWhatsapp(false)} />
      <div className="absolute inset-0 bg-gradient-radial from-warm-beige via-light-warm to-warm-cream opacity-60" />

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div className="mb-6 animate-fade-in-up" onClick={() => window.open("/", "_self")}>
          <img src={logoSrc} alt="The Boggler" className="w-20 h-20 mx-auto object-contain" />
        </div>

        <div className="inline-flex items-center gap-2 bg-orange-cta text-white px-4 py-2 rounded-full text-sm font-montserrat font-semibold mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          Coming Soon
        </div>

        <h1 className="lucky-font text-5xl md:text-7xl text-dark-teal mb-6 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          Boggler Trails
        </h1>

        <p className="text-2xl md:text-3xl text-secondary-text mb-4 font-lato animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          Guidance journals, made for <span className="text-boggler-teal font-bold transition-all duration-500">{rotatingWord}</span>
        </p>

        <p className="text-xl text-primary-text mb-8 font-lato max-w-3xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
          Your guide leaves a <strong>trail</strong> — personalized video journals, screen recordings, written reflections, and recommendations 
          made exclusively for you. Watch and listen to these "trails" <strong>on our TV app</strong>, from your couch, with intention. The trails are stitched together presentations, video, and audio clips made by your guide with the help of AI and The Boggler.
        </p>

        <div className="flex flex-wrap justify-center gap-6 mb-12 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
          <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-full shadow-card">
            <svg className="w-5 h-5 text-boggler-teal" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
            </svg>
            <span className="font-montserrat text-primary-text text-sm">Guides create Trailers on our phone app.</span>
          </div>
          <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-full shadow-card">
            <svg className="w-5 h-5 text-golden-yellow" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
            </svg>
            <span className="font-montserrat text-primary-text text-sm">Addressed to you</span>
          </div>
          <div className="flex items-center gap-2 bg-white px-5 py-3 rounded-full shadow-card">
            <svg className="w-5 h-5 text-orange-cta" fill="currentColor" viewBox="0 0 24 24">
              <path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"/>
            </svg>
            <span className="font-montserrat text-primary-text text-sm">You watch on TV</span>
          </div>
        </div>

        <a
          onClick={() => setShowSelectWhatsapp(true)}
          className="bg-boggler-teal text-white px-10 py-4 rounded-full text-lg font-montserrat font-semibold shadow-boggler btn-hover-lift inline-flex items-center gap-3 animate-fade-in-up"
          style={{ animationDelay: '0.8s' }}
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
          </svg>
          Join the Waitlist
        </a>

        <p className="mt-4 text-muted-text font-lato animate-fade-in-up" style={{ animationDelay: '1s' }}>
          Be the first to receive personal trails on your TV
        </p>

        <div className="mt-16 flex justify-center gap-8 flex-wrap animate-fade-in-up" style={{ animationDelay: '1.2s' }}>
          <div className="bg-white rounded-boggler p-4 shadow-card">
            <div className="w-44 h-80 bg-gray-900 rounded-3xl phone-glow flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-2 bg-gradient-to-b from-boggler-teal to-dark-teal rounded-2xl opacity-20"></div>
              <div className="text-center text-white relative z-10">
                <svg className="w-10 h-10 mx-auto mb-2 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
                </svg>
                <span className="text-xs font-montserrat">Recording for Sarah...</span>
              </div>
            </div>
            <p className="text-xs text-muted-text mt-2 font-lato text-center">Guide creates entry</p>
          </div>
          <div className="bg-white rounded-boggler p-4 shadow-card">
            <div className="w-72 h-44 bg-gray-900 rounded-xl tv-glow flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-boggler-teal to-transparent opacity-10"></div>
              <div className="text-center text-white relative z-10 px-4">
                <p className="text-xs font-montserrat mb-2 opacity-70">New trail from Maya K.</p>
                <p className="text-sm font-lato italic">"Hey Sarah — I've been thinking about what you said..."</p>
              </div>
            </div>
            <p className="text-xs text-muted-text mt-2 font-lato text-center">Sarah watches on Apple TV</p>
          </div>
        </div>
      </div>
    </section>
  );
}
